/**
 * Public referral / partner-program landing page.
 *
 * Like the /welcome landing, this is a fully standalone HTML document (own
 * <head>, fonts, global CSS and inline JS) shipped as a static asset at
 * /partners/index.html. We embed it in a full-screen iframe so its global
 * styles can't collide with the app, and so the URL stays a clean /partners
 * handled by the SPA router.
 *
 * The page's CTA and its internal links navigate window.top, so they break out
 * of the iframe (Telegram opens in the whole tab; "О платформе" / brand go to
 * the /welcome SPA route). It shares the hero-orb asset with /welcome to avoid
 * duplicating the ~4.5 MB gif.
 */
export function PartnersPage() {
  return (
    <iframe
      src="/partners/index.html"
      title="onlymind — Партнёрская программа"
      style={{
        position: 'fixed',
        inset: 0,
        width: '100%',
        height: '100%',
        border: 'none',
      }}
    />
  );
}
